{
  "billing": {
    "title": "Billing",
    "notAuthorized": "Only workspace owners can manage billing."
  },
  "balance": {
    "label": "Credit balance",
    "credits_one": "{{count}} credit",
    "credits_other": "{{count}} credits",
    "available": "{{count}} available",
    "breakdown": "{{purchased}} purchased · {{granted}} gifted"
  },
  "topUp": {
    "cta": "Top up credits",
    "title": "Top up credits",
    "subtitle": "1 credit funds 1 profile.",
    "payWithSaved": "Pay {{total}} with •••• {{last4}}",
    "payNew": "Pay {{total}}",
    "processing": "Processing…",
    "success": "Credits added",
    "genericError": "The payment could not be completed. Please try again.",
    "settlementSlow": "This is taking longer than usual. Your purchase will appear shortly — check Billing."
  },
  "amount": {
    "label": "How many credits?",
    "justEnough": "Just enough",
    "aBitExtra": "A bit extra",
    "roundUp": "Round up",
    "option": "{{credits}} for {{total}}"
  },
  "send": {
    "costSummary": "{{count}} invitations × {{unit}} = {{total}}. You have {{balance}} available.",
    "topUpAndSend": "Top up & send {{count}}"
  },
  "self": {
    "ctaHasCredits": "Profile yourself (uses 1 credit)",
    "ctaBuy": "Buy a profile for yourself — {{price}}",
    "askOwner": "Ask a workspace owner to top up credits."
  },
  "paymentMethod": {
    "title": "Payment method",
    "none": "No card on file.",
    "card": "{{brand}} •••• {{last4}}",
    "expires": "Expires {{month}}/{{year}}",
    "replace": "Replace card",
    "replaceTitle": "Replace your card",
    "replaceCta": "Save card",
    "replaceSuccess": "Card updated",
    "businessNameLabel": "Business name (optional)",
    "businessNamePlaceholder": "For business invoicing",
    "taxIdLabel": "Tax ID (optional)",
    "taxIdPlaceholder": "EU VAT number, if you have one"
  },
  "history": {
    "title": "Purchase history",
    "empty": "No purchases yet.",
    "creditsColumn": "Credits",
    "date": "Date",
    "amount": "Amount",
    "status": "Status",
    "invoice": "Invoice",
    "invoicePending": "Preparing…"
  }
}
